import React from 'react';
import './collaborators.scss';
import DocumentsTab from '../documents/collaboratorDocs.js';

const AREA_COLLABORATOR = 2;

export default function CollaboratorDocs(props) {

    return (
        <div>
            <div className="offer-title" align="left" > 
                <h2>Documenti {props.data.data.nome} {props.data.data.cognome}</h2>
            </div>

                <DocumentsTab collaboratorId = {props.data.key} area = {AREA_COLLABORATOR}></DocumentsTab>

        </div>
    
)};